<template>
  <card>
    <div class="card-header pt-0">
      <h4 class="title mt-0">
        Uncertified Participants
      </h4>
    </div>
    <el-table
      class="table"
      style="width: 100%"
      :header-cell-style="headerCellStyle"
      :cell-style="cellStyle"
      :data="tickets"
    >
      <el-table-column
        label="Participant"
        prop="FullName"
        width="150"
        class-name="text-left"
      />
      <el-table-column
        label="Patrol"
        prop="Critter"
        width="80"
        class-name="text-center"
      />
      <el-table-column label="Comments">
        <template slot-scope="props">
          <fg-input
            name="comments"
            max-length="1500"
            v-model="props.row.TicketCompletionComments"
            :title="props.row.TicketCompletionComments"
          />
        </template>
      </el-table-column>
      <el-table-column
        label="Submit"
        width="110"
      >
        <template slot-scope="props">
          <button
            type="submit"
            class="btn btn-primary mb-1"
            @click="updateRow(props.row.ScouterKey)"
          >
            Update
          </button>
        </template>
      </el-table-column>
    </el-table>
  </card>
</template>

<script>
import ticketApi from '@/services/api/ticket.js'

export default {
  name: 'ReportCloseoutUncertifiedParticipantEdit',
  components: {},
  data: function () {
    return {
      tickets: [],
      cellStyle: {
        padding: '0',
        'font-size': '10px',
        'text-align': 'center',
        'vertical-align': 'baseline'
      },
      headerCellStyle: {
        padding: '0 0 0 0 !important',
        margin: '0',
        height: '20px',
        'font-size': '10px',
        'vertical-align': 'baseline',
        'text-align': 'center',
        'overflow-wrap': 'break-word'
      }
    }
  },
  mounted: function () {
    ticketApi
      .getIncompleteTickets(this.$root.courseKey)
      .then(x => {
        this.tickets = x
      })
      .catch(error => {
        console.log(error)
        this.$notify({
          message: 'There was an error retrieving your data.',
          icon: 'bi bi-exclamation-circle-fill',
          type: 'error',
          horizontalAlign: 'center',
          timeout: 2000
        })
        this.errormessage = error
      })
      .finally(() => {
        this.loading = false
      })
  },
  methods: {
    getTicket: function (scouterKey) {
      let returnValue = null
      for (let i = 0; i < this.tickets.length; i++) {
        if (this.tickets[i].ScouterKey === scouterKey) {
          returnValue = this.tickets[i]
          break
        }
      }
      return returnValue
    },
    updateRow: function (scouterKey) {
      const row = this.getTicket(scouterKey)
      alert(row.TicketCompletionComments)
      if (row !== null) {
        ticketApi
          .updateComments(
            this.$root.courseKey,
            scouterKey,
            row.TicketCompletionComments
          )
          .then(x => {
            this.tickets = x
            this.$notify({
              message: 'Update complete.',
              icon: 'nc-icon nc-satisfied',
              type: 'success',
              horizontalAlign: 'center',
              timeout: 2000
            })
          })
          .catch(error => {
            console.log(error)
            this.$notify({
              message: 'There was an error updating your info.',
              icon: 'bi bi-exclamation-circle-fill',
              type: 'error',
              horizontalAlign: 'center',
              timeout: 2000
            })
            this.errormessage = error
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
}
</script>
